import React from 'react';

const ServiceInsight = () => {
  return (
    <section className="py-12 sm:py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 font-sans">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        
        {/* Large Featured Card 1 */}
        <div className="group bg-white flex flex-col md:flex-row overflow-hidden cursor-pointer md:col-span-2 border border-gray-100 rounded-sm hover:shadow-lg hover:border-cogCyan/20 transition-all duration-300">
          <div className="md:w-3/5 overflow-hidden relative min-h-[240px]">
            <img 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" 
              alt="Technicians assembling wiring harnesses on a factory production line, cutting, crimping, and connecting cables at organized workstations under bright industrial lighting." 
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQSW85DQVnc8h6fp8EXGMnViWlxOTjDKRF2pq301mMrZWkzdUPn69lLN3q9&s=10"
            />
          </div>
          <div className="md:w-2/5 p-6 sm:p-8 flex flex-col justify-center">
            <span className="text-xs sm:text-sm font-semibold text-cogBlue/60 uppercase tracking-wider mb-2">
              Manufacturing
            </span>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-4 text-cogBrand group-hover:text-cogCyan transition-colors duration-200 tracking-tight">
              Precision manufacturing, built for consistency at volume
            </h2>
            <p className="text-sm sm:text-base text-cogBlue/80 mb-6 leading-relaxed">
              Our in-house facility handles the complete assembly cycle, from automatic wire
              cutting, stripping, and crimping through connector assembly, piping and T-joint
              looping, branching, and soldering. Advanced, high-technology equipment keeps
              rejection rates low and delivery timelines predictable, while shift-based operations
              let us flex production speed and volume up or down as your orders require. Every
              stage is overseen by an experienced technical team, so the process stays consistent
              whether we're running a single prototype or a full production batch.
            </p>
          </div>
        </div>

        {/* Article 2 */}
        <div className="group bg-white overflow-hidden cursor-pointer border border-gray-100 rounded-sm hover:shadow-lg hover:border-cogCyan/20 transition-all duration-300 flex flex-col justify-between">
          <div>
            <div className="h-64 overflow-hidden relative">
              <img 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" 
                alt="A technician using a crimp pull-force tester and continuity testing equipment on finished wiring harnesses at an inspection bench." 
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1i6ZfEJb_W6RFT09zQSX4M_HYm30i6dzjVkB5F-5_FvMLDB9NOglwdqE&s=10"
              />
            </div>
            <div className="p-6 sm:p-8">
              <span className="text-xs sm:text-sm font-semibold text-cogBlue/60 uppercase tracking-wider mb-2 block">
                Testing
              </span>
              <h3 className="text-lg sm:text-xl font-bold mb-3 text-cogBrand group-hover:text-cogCyan transition-colors duration-200 tracking-tight">
                Testing & Inspection
              </h3>
              <p className="text-sm sm:text-base text-cogBlue/80 leading-relaxed">
                Every harness is checked on a dedicated testing rig for continuity and correct
                pinout before it's approved for dispatch, and crimp connections are verified on a
                pull-force tester to confirm they meet strength requirements. Each unit is then
                barcode-labeled, so it stays traceable from the production floor through final
                inspection, packing, and delivery to your line.
              </p>
            </div>
          </div>
        </div>

        {/* Article 3 */}
        <div className="group bg-white overflow-hidden cursor-pointer border border-gray-100 rounded-sm hover:shadow-lg hover:border-cogCyan/20 transition-all duration-300 flex flex-col justify-between">
          <div>
            <div className="h-64 overflow-hidden relative">
              <img 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" 
                alt="A quality inspector reviewing documentation and a certification binder in a clean, organized manufacturing facility." 
                src="https://img.magnific.com/free-photo/electrical-panel-with-fuses-contactors-closeup_169016-52159.jpg?semt=ais_hybrid&w=740&q=80"
              />
            </div>
            <div className="p-6 sm:p-8">
              <span className="text-xs sm:text-sm font-semibold text-cogBlue/60 uppercase tracking-wider mb-2 block">
                Quality
              </span>
              <h3 className="text-lg sm:text-xl font-bold mb-3 text-cogBrand group-hover:text-cogCyan transition-colors duration-200 tracking-tight">
                Quality Assurance
              </h3>
              <p className="text-sm sm:text-base text-cogBlue/80 leading-relaxed">
                Our management system is certified to ISO 9001:2015 for the manufacturing,
                assembly, trading, and supply of electrical wiring harnesses, battery cable
                assemblies, and automotive, EV, and industrial cable assemblies. A dedicated
                quality team reviews each batch at final inspection, and every shipment goes out
                with the same documented standard behind it, so on-time delivery never comes at
                the cost of consistency.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ServiceInsight;